import TYPES from '../actions/types';

const INITIAL_STATE = {
    list: [],
    paging: {},
    filter: {}
};

export const trainerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TYPES.SET_TRAINERS:
            const { count, current, page, pageCount, sort, direction } = action.payload.paging;
            return {
                ...state, 
                list: action.payload.list, 
                paging: { count, current, page, pageCount, sort, direction }
            };

        case TYPES.SELECT_TRAINER:
            return {
                ...state,
                selected: action.payload
            };

        case TYPES.SET_TRAINER_FILTER:
            return {
                ...state,
                filter: action.payload,
                paging: {}
            };
        
        default:
            return state;
    }
};